import { Field } from "../Layout/Field";

import { Input } from "@/components/ui/input";

interface RegexFieldProps {
  regexPattern: string;
  onRegexPatternChange: (value: string) => void;
}

export const RegexField = ({ regexPattern, onRegexPatternChange }: RegexFieldProps) => (
  <Field label="Regex pattern">
    <Input
      value={regexPattern}
      onChange={event => onRegexPatternChange(event.target.value)}
      placeholder=".*"
      className="font-mono text-sm"
    />
  </Field>
);
